import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { localize } from '@saviynt/common';
import { Typography } from '@saviynt/design-system';
import moment from 'moment';
import PropTypes from 'prop-types';

import { setIsARSModalOpen } from '../../../../../../redux/certdetails/action';
import {
  CAMPAIGN_TYPES,
  CAMPAIGNTYPE_ENTITLEMENTOWNER,
  DATE_COLUMNS,
} from '../../../../../../utils/constant';
import { getMessageKey } from '../../../../../../utils/utils';
import { ARS_KEYS } from '../../../../../AccessRequestHistory';
import { SIDEPANEL_FIXED_COLUMNS } from '../../../../../ViewControls';
import { FieldSet } from '../../../SidePanelCommon';
import { MANDATORY_COLUMNS_MSG_KEY } from '../constant';
import DATA from '../mockData';
import {
  getEOCampaignFilteredNodeData,
  getFilteredNodeData,
  shouldShowArsButton,
} from '../utils';

function CertsSidePanelBodySummary({ data }) {
  const intl = useIntl();
  const dispatch = useDispatch();

  const { messages } = useSelector((state) => state?.user);
  const { columnPickerList, globalDateFormat, columnLabelKeys } = useSelector(
    (state) => state?.certifications?.details?.global
  );
  const {
    core: { campaignType },
  } = useSelector((state) => state?.certifications?.details);
  const isEOCampaign =
    CAMPAIGN_TYPES[campaignType] === CAMPAIGNTYPE_ENTITLEMENTOWNER;

  const [colsToShow, setColsToShow] = useState({});

  useEffect(() => {
    if (columnPickerList) setColsToShow(columnPickerList);
  }, [columnPickerList]);

  const handleARSModalForSidePanel = () => {
    const payload = {
      ARSTASKKEY: data?.ARSTASKKEY,
      ARSTASKKEYFLAG: data?.arstaskkeyflag,
      CERT_ENTITLEMENT_VALUEKEY: data?.CERT_ENTITLEMENT_VALUEKEY,
      CERT_USERKEY: data?.CERT_USERKEY,
      CERT_ROLEKEY: data?.CERT_ROLEKEY,
      CERT_ACCOUNTKEY: data?.CERT_ACCOUNTKEY,
    };

    dispatch(setIsARSModalOpen(true, payload));
  };

  const getSidePanelNodeDataToView = (sidePanelSummaryNodedata) => {
    let output = {};

    output = isEOCampaign
      ? getEOCampaignFilteredNodeData(
          {
            CERT_ENTITLEMENT_VALUEKEY: data?.ROW_TYPE?.toString(),
            ...sidePanelSummaryNodedata,
          },
          colsToShow
        )
      : getFilteredNodeData(
          {
            CERT_ENTITLEMENT_VALUEKEY: data?.CERT_ENTITLEMENT_VALUEKEY,
            ...sidePanelSummaryNodedata,
          },
          colsToShow
        );

    return output;
  };

  const sidePanelSummaryData = getSidePanelNodeDataToView({
    ...data?.sidePanel?.summary,
    ARSTASKKEY: data?.ARSTASKKEY,
    ACCESSTHROUGH: data?.ACCESSTHROUGH,
    arstaskkeyflag: data?.arstaskkeyflag,
  });

  return (
    <div className='CertsSidePanelBody-tabContentSummaryAttributes'>
      <Typography kind='h4'>
        {messages.CERTS_ATTRIBUTES ||
          localize(intl, getMessageKey('CERTS_ATTRIBUTES'))}
      </Typography>
      {Object.keys(sidePanelSummaryData)
        .filter(
          (key) =>
            (typeof sidePanelSummaryData[key] !== 'object' ||
              sidePanelSummaryData[key] === null) &&
            !SIDEPANEL_FIXED_COLUMNS.includes(key)
        )
        .map((key) => {
          const getSummaryKey = data?.sidePanel?.summary[key];
          const fieldLabel =
            messages[MANDATORY_COLUMNS_MSG_KEY[columnLabelKeys[key]]] ||
            messages[columnLabelKeys[key]] ||
            localize(intl, getMessageKey(key));
          const isNoValue =
            getSummaryKey === null ||
            getSummaryKey === undefined ||
            typeof getSummaryKey === 'object' ||
            (typeof getSummaryKey === 'string' &&
              getSummaryKey?.trim()?.length === 0);

          let fieldValue = isNoValue ? '-' : `${getSummaryKey}`;

          if (ARS_KEYS.includes(key) && shouldShowArsButton(data)) {
            fieldValue = (
              <span
                onClick={handleARSModalForSidePanel}
                onKeyDown={() => {}}
                role='button'
                tabIndex='0'
                className='AccessRequestHistoryBtn-sidePanelMode'>
                {messages.CERTS_ACCESS_REQUEST ||
                  localize(intl, getMessageKey('CERTS_ACCESS_REQUEST'))}
              </span>
            );
          }

          if (DATE_COLUMNS.includes(key) && getSummaryKey) {
            fieldValue = moment
              .utc(getSummaryKey)
              .local()
              .format(`${globalDateFormat?.toUpperCase()} HH:mm:ss`);
          }

          if (
            getSummaryKey &&
            typeof getSummaryKey === 'string' &&
            getSummaryKey?.includes('<br')
          ) {
            fieldValue = fieldValue?.replace(/<br\s*\/?>/gm, '\n');
          }

          return (
            <FieldSet
              key={key}
              fieldData={{
                label: fieldLabel,
                value: fieldValue,
              }}
              isLink={ARS_KEYS.includes(key) && shouldShowArsButton(data)}
            />
          );
        })}
    </div>
  );
}

CertsSidePanelBodySummary.propTypes = { data: PropTypes.shape(DATA) };

CertsSidePanelBodySummary.defaultProps = { data: null };

export default CertsSidePanelBodySummary;
